import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./pages/landing/landing-routing.module').then((m) => m.routes),
  },
  // {
  //   path: "",
  //   loadChildren: () => import("./pages/sub-landing/sub-landing.module").then(() => SubLandingModule)
  // },
  {
    path: '',
    // loadChildren: () =>
    //   import('./pages/ticketing/ticketing.module').then(() => TicketingModule),
    loadChildren: () =>
      import('./pages/ticketing/ticketing-routing.module').then(
        (m) => m.routes
      ),
  },
  {
    path: '',
    loadChildren: () =>
      import('./pages/dashboard/dashboard-routing.module').then(
        (m) => m.routes
      ),
    canActivate: [authGuard],
  },
  // {
  //   path: '',
  //   loadChildren: () =>
  //     import('./pages/auth/auth.module').then(() => AuthModule),
  // },
  {
    path: 'search-results',
    loadChildren: () =>
      import('./pages/search-results/search-results-routing.module').then(
        (m) => m.routes
      ),
  },
  {
    path: 'card',
    loadChildren: () =>
      import('./pages/card/card-routing.module').then((m) => m.routes),
    canActivate: [authGuard],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
      scrollPositionRestoration: 'top',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
